import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/hera.webp';
import screenshot_target from '../../../images/letterfunnel/susanvangeenen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Susan van Geenen"
      firstname="Susan"
      companyname="HERA"
      competition="AFC Ajax Vrouwen en FC Twente Vrouwen"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/susanvangeenen.js